/**
 * Ziel der Nav-Knoepfe (Jans Fund 22.09.2026: „die NAV-Buttons ueberspringen
 * manchmal einen Slide", „am Ende kommt man mit dem Pfeil nach oben nicht
 * zurueck", „vom ersten Slide nicht wieder zum Start").
 *
 * Frueher: aktueller Slide = der, in dessen KASTEN die Scroll-Position liegt,
 * dann ±1. Bei Slides OHNE Text liegt die Zielposition (textCenter) aber genau
 * auf der Unterkante des Kastens — ein Pixel weiter (Rundung am Tween-Ende)
 * und der Knopf hielt schon den naechsten Slide fuer den aktuellen: der
 * naechste Klick sprang einen zu weit. Am Story-Ende ohne Text galt der letzte
 * Slide schon als „hinter der Story" und „hoch" zielte auf ihn selbst.
 *
 * Jetzt allein nach den ZIELPOSITIONEN: runter = das naechste Ziel UNTER der
 * aktuellen Position, hoch = das naechste Ziel DARUEBER. Gibt es keins, geht
 * es zu den Credits bzw. zurueck zum Start (Cover).
 */
export type NavZiel = number | "start" | "credits";

/** Toleranz in px, damit Rundung am Tween-Ende nicht als „schon weiter" zaehlt. */
export const NAV_TOLERANZ_PX = 4;

export function navZiel(
    ziele: readonly number[],
    scrollTop: number,
    richtung: "hoch" | "runter",
    toleranz = NAV_TOLERANZ_PX,
    /** ZWEIMAL KLICKEN (Jans Fund 15.10.2026, „man muss den NAV-Button zurück
     *  zum START zweimal klicken"): Das Ziel des Titel-Slides liegt (ohne
     *  Rast) genau HINTER dem Cover — der erste Klick landete dort, sah aus
     *  wie der Start, aber ohne START-Knopf. Liegt Ziel 0 bis zu dieser
     *  Scroll-Position (Cover-Höhe), zählt es beim Hoch-Pfeil als „start". */
    startSchwelle?: number,
): NavZiel {
    const s = Number.isFinite(scrollTop) ? scrollTop : 0;
    if (richtung === "runter") {
        for (let i = 0; i < ziele.length; i++) {
            if (ziele[i] > s + toleranz) return i;
        }
        return "credits";
    }
    for (let i = ziele.length - 1; i >= 0; i--) {
        if (ziele[i] < s - toleranz) {
            if (i === 0 && startSchwelle !== undefined && ziele[0] <= startSchwelle + toleranz) {
                return "start";
            }
            return i;
        }
    }
    return "start";
}
